import React from 'react';

export const LinkedAccountIcon = (props) => {
  const { className = '', style = {}, onClick } = props;
  return (
    <svg
      className={className}
      style={style}
      width="40"
      height="32"
      viewBox="0 0 40 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="0.5" y="0.5" width="39" height="31" rx="15.5" fill="#51B4F6" />
      <rect x="0.5" y="0.5" width="39" height="31" rx="15.5" stroke="#51B4F6" />
      <g clip-path="url(#clip0_372_20710)">
        <path
          d="M17.0874 20H15.3771C13.5106 20 12 18.3645 12 16.3645V15.6355C12 13.6355 13.5193 12 15.3771 12H17.0874C17.5214 12 17.8687 12.3738 17.8687 12.8411C17.8687 13.3084 17.5214 13.6822 17.0874 13.6822H15.3771C14.3787 13.6822 13.5627 14.5607 13.5627 15.6355V16.3645C13.5627 17.4393 14.3787 18.3178 15.3771 18.3178H17.0874C17.5214 18.3178 17.8687 18.6916 17.8687 19.1589C17.8687 19.6262 17.5214 20 17.0874 20ZM28 16.3645V15.6355C28 13.6262 26.4807 12 24.6229 12H22.8171C22.3831 12 22.0358 12.3738 22.0358 12.8411C22.0358 13.3084 22.3831 13.6822 22.8171 13.6822H24.6229C25.6213 13.6822 26.4373 14.5607 26.4373 15.6355V16.3645C26.4373 17.4393 25.6213 18.3178 24.6229 18.3178H22.8171C22.3831 18.3178 22.0358 18.6916 22.0358 19.1589C22.0358 19.6262 22.3831 20 22.8171 20H24.6229C26.4894 20 28 18.3645 28 16.3645ZM23.8416 16C23.8416 15.5327 23.4943 15.1589 23.0602 15.1589H16.9485C16.5144 15.1589 16.1671 15.5327 16.1671 16C16.1671 16.4673 16.5144 16.8411 16.9485 16.8411H23.0602C23.4943 16.8411 23.8416 16.4673 23.8416 16Z"
          fill="#1C1C1C"
        />
      </g>
      <defs>
        <clipPath id="clip0_372_20710">
          <rect width="24" height="24" fill="white" transform="translate(8 4)" />
        </clipPath>
      </defs>
    </svg>
  );
};
